// extracted by mini-css-extract-plugin
module.exports = {"userCard":"user-card_userCard__-cReS"};